<template>
    <div id="biodigestor-general-view-widget-component">
        <WidgetWrapperComponent :title="$t('information_asset_widget_component.general_view')" id-widget="biodigestor-general-view-widget">
            <template v-slot:default>
                <div>
                    <div class="d-flex gap-5 mb-2 justify-center align-center">
                        <div class="d-flex align-center justify-center">
                            <DisplayAssetContentLevelComponent :asset="asset" :asset_module="assetModule" :index_model="0" />
                        </div>
                        <div>
                            <p class="font-14 mb-0 font-color-medium">
                                {{ $t('daily_add') }}
                            </p>
                            <p class="primary--text font-weight-bold font-24">{{ dailyApport }} Kg</p>
                        </div>
                    </div>

                    <div class="d-flex flex-row justify-center align-center gap-3 mb-2">
                        <template v-if="!fetchingDateLastEmission" class="d-flex flex-row justify-center align-center gap-3 mb-2">
                            <v-chip :color="isOnline() ? 'success' : 'error'" small outlined>
                                <div class="d-flex align-center gap-2">
                                    <v-icon :color="isOnline() ? 'success' : 'error'" small> mdi-circle</v-icon>
                                    <span :class="isOnline() ? 'success--text' : 'error--text'">
                                        {{ isOnline() ? $t('online') : $t('offline') }}
                                    </span>
                                </div>
                            </v-chip>
                            <span class="text-skin-light text-sm" v-if="lastDate">
                                {{ `${$t('date_last_emission')}: ${lastDate.toLocaleDateString()}  ${lastDate.toLocaleTimeString()}` }}
                            </span>
                        </template>
                        <template v-else>
                            <v-chip color="primary" density="comfortable" size="small" variant="outlined">
                                <div class="d-flex align-center gap-2">
                                    <v-progress-circular color="white" size="12" width="2" indeterminate />
                                    <span class="white--text"> {{ $t('loading') }}... </span>
                                </div>
                            </v-chip>
                        </template>
                    </div>

                    <div class="d-flex gap-2 justify-space-around text-center">
                        <div>
                            <p class="font-14 font-color-medium mb-0">
                                {{ $t('humidity') }}
                            </p>
                            <span>{{ humidity }} %</span>
                        </div>
                        <v-divider vertical />
                        <div>
                            <p class="font-14 font-color-medium mb-0">
                                {{ $t('tankTemp') }}
                            </p>
                            <span>{{ temperature }} °C</span>
                        </div>
                        <v-divider vertical />
                        <div>
                            <p class="font-14 font-color-medium mb-0">
                                {{ $t('temperature_oil') }}
                            </p>
                            <span>{{ temperatureOil }} °C</span>
                        </div>
                    </div>
                </div>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import deviceRepository from '@/repositories/DeviceRepository'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import DisplayAssetContentLevelComponent from '@/components/equipment/generic/containment/DisplayAssetContentLevelComponent.vue'

export default {
    name: 'BiodigestorGeneralViewWidgetComponent',
    components: {
        DisplayAssetContentLevelComponent,
        WidgetWrapperComponent,
    },
    props: {
        asset: {
            type: Object,
            required: true,
        },
        assetModule: {
            type: Object,
            required: true,
        },
        device: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dailyApport: 0,
            humidity: 0,
            temperature: 0,
            temperatureOil: 0,
            fetchingDateLastEmission: false,
            lastDate: null,
        }
    },
    async mounted() {
        await this.fetchLastDataInformation()
        await this.fetchLastConnexion()
    },
    methods: {
        isOnline() {
            const limit = new Date(new Date().getTime() - 20 * 60 * 1000)

            return this.lastDate && this.lastDate > limit
        },
        async fetchLastDataInformation() {
            await deviceRepository
                .getBiodigestorInformationByDevice(this.device.device_number)
                .then((success) => {
                    this.humidity = success.data.data.humidity
                    this.temperature = success.data.data.tank_temp
                    this.temperatureOil = success.data.data.oil_temp
                    this.dailyApport = success.data.data.daily_operation
                })
                .catch((error) => {
                    this.manageError(error)
                })
        },
        async fetchLastConnexion() {
            this.fetchingDateLastEmission = true
            await deviceRepository
                .getBiodigestorLastConnexion(this.device.device_number)
                .then((success) => {
                    const fixedIso = success.data.data.replace(/(\.\d{3})\d*Z$/, '$1Z')
                    this.lastDate = new Date(fixedIso)
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetchingDateLastEmission = false
                })
        },
    },
}
</script>
